
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(window).on('load',function(event) {
     
      function wishListCollection() {
//Remove Below Condition if you wish to show it on Product page also 
        if (Flits.request.page_type == 'collection' || Flits.request.page_type == 'product' || Flits.request.page_type == 'search') {
          let collectionBtn = Flits('.flits-wishlist-colection');
          parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
            Flits(collectionBtn).show(),
            Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
        }
      }
    wishListCollection();
  });
  
  
  if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
    Flits(document).on("Flits:Loaded",function(){
      Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
    })
    
  }
  Flits(document).on('Flits:wishlistButton:Loaded', function(event){
    if (Flits.request.page_type == 'index' || Flits.request.page_type == 'product'|| Flits.request.page_type == 'search' ) {
      let collectionBtn = Flits('.flits-wishlist-colection');
      parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
        Flits(collectionBtn).show(),
        Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
    }
  });
  Flits(document).on("click", ".flits-add-to-cart", function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    let el = Flits(this);
    let quantity = parseInt(Flits(el).parents(".flits-product-card").find('input[name="product_quantity_input"]').val());
    let maxLimit = parseInt(Flits(el).parents(".flits-product-card").find('input[name="product_quantity_input"]').attr("max"));
    let id = Flits(el).parents(".flits-product-card").find(".flits-variant-select").val();
    let interval = 0;
    cartOrder[id] &&
      quantity + parseInt(cartOrder[id].cart_quantity) > maxLimit &&
      ((quantity = maxLimit - parseInt(cartOrder[id].cart_quantity)),
       quantity == 0 ? (quantity = maxLimit) : quantity,
       (interval = 3000),
       flitsSnackbar.show({ text: Flits.t("Flits.locals.general.cart_updated", "Some items are no longer available. Your cart has been updated."), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default" }));
    let data = "id=" + id + "&quantity=" + quantity;
    setTimeout(function () {
     	addToCartN(data);
    }, interval);
    return false;
  });
  function addToCartN(params) {
    console.log(params)
    flitsSnackbar.show({ text: Flits.t("Flits.locals.cart_page.adding_items_to_cart", "Adding items to cart..."), pos: "bottom-center", showAction: !1, customClass: "flits-alert-default", duration: !1 }),
      Flits.ajax({ type: "POST", url: "/cart/add.js", data: params, dataType: "json" })
    .done(function (resp) {
      Flits.flitsSnackbarHide(); //(location.href = "/cart");
      $.ajax({
        type: 'get',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          $('.site-header-cart--count').attr('data-header-cart-count', cart.item_count);
          $('.site-header-cart--count').addClass('visible');
          flitsSnackbar.show({ text: Flits.t("Flits.locals.cart_page.items_added_to_cart", "Item Added to cart"), pos: "bottom-center", showAction: !1, customClass: "flits-alert-success", duration: 1501 });
        }
      });
      })
    .fail(function (resp) {
      flitsSnackbar.show({ text: resp.responseJSON.description, pos: "bottom-center", showAction: !1, customClass: "flits-alert-error" });
    })
    .always(function () {});
  }
  
  window.flitswishlistResponse = {};
  Flits(document).on('Flits:Wishlist:AjaxSuccessful',function(event){
    var data = event.detail;
    window.flitswishlistResponse = data.resp;
  });
  Flits(document).on('Flits:getShopifyProductData:complete',function(event){
    var data = event.detail;  
    if(Flits(data.item).hasClass('flits-wishlist-card')){
      if(!data.status){      
        var itemDom = data.item;	
        var product = flitsGetProductDetailsFromWishlistResponse(data.handle);
        let image = "https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif";
        product.product_image != null && (image = product.product_image);
        let extidx = image.lastIndexOf(".");
        let extension = image.substr(extidx);
        (image = image.replace(extension, "_200x_crop_center" + extension)), Flits(itemDom).find(".flits-product-image-thumbnail img").attr("src", image);
        let imgWidth = Flits(itemDom).find(".flits-product-image img").width();
        let imgHeight = Flits(itemDom).find(".flits-product-image img").height();
        imgWidth > imgHeight;
        Flits(itemDom).find(".flits-product-name").html(product.product_title );
         Flits(itemDom).find(".flits-product-name").attr("data-tippy-content", product.product_title );
        Flits(itemDom).find(".flits-product-price").html(Flits.formatMoney(Math.abs(0 * 100), Flits.money_format));
        Flits(itemDom).find(".flits-product-price").css({
          visibility:"hidden"
        });
        Flits(itemDom).find(".flits-select-row").css({
          visibility:"hidden"
        });              
        Flits(itemDom).find(".flits-floating-label .flits-variant-select").hide();       
        Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-id", product.product_id );
        Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-title", product.product_title);
        Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-handle", product.product_handle );
        Flits(itemDom).find(".flits-add-to-cart").attr("data-remove", product.product_id);
        let sold_out_text = Flits(itemDom).find(".flits-add-to-cart").attr("data-flits-sold-text");
        Flits(itemDom).find(".flits-add-to-cart").addClass("flits-btn-danger");
        Flits(itemDom).find(".flits-add-to-cart").attr("disabled", !0);
        Flits(itemDom).find(".flits-add-to-cart").text(sold_out_text);
        Flits(itemDom).find(".flits-product-quantity").addClass("flits-disabled");        
      }
    }
    else if(Flits(data.item).find('.flits-product-card').hasClass('flits-recently-view-card')){    
      if(!data.status){
        Flits(data.item).css("display","none")
      }
    }
  });

  function flitsGetProductDetailsFromWishlistResponse(handle){
    var item_details = undefined;
    Flits.each(window.flitswishlistResponse.data,function(index,item){
      if(item.product_handle == handle){
        item_details = item;
        return false;
      }
    });
    return item_details;
  }
}(Flits));
